module.exports = __webpack_public_path__ + "static/media/2.2bd6ff66.jpg";